import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { ImageOptions, ProjectCardItem } from 'app/core/cms/generated/api-types'
import { createCmsLinkFromCardItem } from 'app/utils/create-cms-link-from-card-item.function'
import { explicitComputed } from 'app/utils/signal-utils'

import { AnchorCardComponent } from '../anchor-card/anchor-card.component'

@Component({
  selector: 'pai-project-item-card',
  imports: [AnchorCardComponent],
  templateUrl: './project-item-card.component.html',
  styleUrl: './project-item-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectItemCardComponent {
  readonly project = input.required<ProjectCardItem>()
  protected readonly target = explicitComputed(this.project, createCmsLinkFromCardItem)
  protected readonly imgOpts: ImageOptions = { objectFit: 'cover', ratio: '_5_3' }
}
